import { memberClient, memberWithAuthClient } from './client';

/**
 * 取得使用者自選列表
 * @returns
 */
export const GETv1UserProfile = () => {
  const url = `/member-always-right/api/v1/portfolios`;

  return memberWithAuthClient.get(url);
};

/**
 * 新增商品到自選列表
 * @productType {string} 商品類別
 * @productId {string} 商品Id
 * @groupIds {number[]} 群組Id
 * @returns {Promise}
 */
export function POSTv1AddProduct({ productId, groupIds }: { productId: string; groupIds: number[] }) {
  const url = `/member-always-right/api/v1/portfolios/${productId}`;
  const body = {
    product_type: 'GLOBAL_STOCK',
    groups: groupIds
  };

  return memberWithAuthClient.post(url, { body });
}

/**
 * 刪除商品到自選列表
 * @productId {string} 商品Id
 * @groupIds {number[]} 群組Id
 * @returns {Promise}
 */
export function DELETEv1RemoveProduct({ productId, groupIds }: { productId: string; groupIds: number[] }) {
  const url = `/member-always-right/api/v1/portfolios/${productId}?groups=${encodeURIComponent(groupIds.toString())}`;

  return memberWithAuthClient.delete(url);
}

/**
 * 判斷信箱是否已註冊
 * /member/api/v1/user/email/isMemberEmail
 * @export POSTv1MemberEmail
 * @param string email - client
 * @returns {Promise}
 */
export function POSTv1MemberEmail(email: string) {
  const url = '/member/api/v1/user/email/isMemberEmail';
  const body = {
    email: email
  };

  return memberClient.post(url, { body });
}

/**
 * @description 用來要求重新寄送驗證信的函示
 * @export POSTv1ResendEmail
 * @param string email - client
 * @returns {Promise}
 */
export function POSTv1ResendEmail(email: string) {
  const url = '/member/api/v1/user/email/resend';
  const body = {
    email: email
  };

  return memberClient.post(url, { body });
}

/**
 * 訂閱早報
 * /member-always-right/api/v1/newsletter/subscription
 * @export POSTv1NewsletterSubscriptioninator
 * @param string email - client
 * @returns {Promise}
 */
export function POSTv1NewsletterSubscriptioninator(email: string) {
  const url = '/member-always-right/api/v1/newsletter/subscription';
  const body = {
    email: email
  };

  return memberClient.post(url, { body });
}
